export const meta = {
    title: "DMARCFlow | DMARC Monitoring with AI – Stop Email Spoofing",
    description: "Check your domain with DMARC Flow. Powerful DMARC, SPF, and DKIM monitoring – AI-supported, no DNS skills required. Prevent spoofing and phishing now.",
    ogTitle: "AI-Powered DMARC, SPF, DKIM – Email Security Made Simple",
}